import { useState } from 'react';
import { useDebounce, useWindowScroll, useWindowSize } from '@client/common/hooks';

const SCROLL_RESIZE_DEBOUNCE = 50;
const TOP_PRELOAD_OFFSET = 700;
const BOTTOM_PRELOAD_OFFSET = 700;

export type UseElementVisibilityReturnType = {
  isElementVisible: (ref: HTMLElement) => boolean;
  scrollPosition: number;
};

export const useElementVisibility = (): UseElementVisibilityReturnType => {
  const { height } = useWindowSize();
  const { y } = useWindowScroll();
  const [scrollPosition, setScrollPosition] = useState(y);
  const [windowHeight, setWindowHeight] = useState(height);

  useDebounce(
    (): void => {
      setScrollPosition(y);
    },
    SCROLL_RESIZE_DEBOUNCE,
    [y],
  );

  useDebounce(
    (): void => {
      setWindowHeight(height);
    },
    SCROLL_RESIZE_DEBOUNCE,
    [height],
  );

  return {
    isElementVisible: (ref: HTMLElement): boolean => {
      const rect = ref.getBoundingClientRect();

      return (
        -TOP_PRELOAD_OFFSET < rect.bottom
        && windowHeight + BOTTOM_PRELOAD_OFFSET > rect.top
      );
    },
    scrollPosition,
  };
};
